import { useGetMerchantTerminalContractsQuery } from "Api/Queries/Merchants/useGetMerchantTerminalContractsQuery";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { TerminalContracts } from "Components/Shared/Merchant/Products/TerminalContracts/TerminalContracts";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Merchant.TerminalContracts;

type Props = {
  merchantPublicID: string;
  isReadOnly?: boolean;
};

export const Terminals = ({ merchantPublicID, isReadOnly = false }: Props) => {
  const { t } = useResource();
  const { data: terminalContracts, isLoading } =
    useGetMerchantTerminalContractsQuery(merchantPublicID);

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  if (!terminalContracts?.items) {
    return <div>{t(COMPONENT_RESOURCES.NoTerminalContracts)}</div>;
  }

  return (
    <TerminalContracts
      merchantPublicID={merchantPublicID}
      contracts={terminalContracts.items}
      isReadOnly={isReadOnly}
    />
  );
};
